/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PractitionerSearchResult } from './PractitionerSearchResult';
import {
    PractitionerSearchResultFromJSON,
    PractitionerSearchResultFromJSONTyped,
    PractitionerSearchResultToJSON,
    PractitionerSearchResultToJSONTyped,
} from './PractitionerSearchResult';

/**
 * 
 * @export
 * @interface PractitionerSearchResponse
 */
export interface PractitionerSearchResponse {
    /**
     * 
     * @type {Array<PractitionerSearchResult>}
     * @memberof PractitionerSearchResponse
     */
    data: Array<PractitionerSearchResult>;
}

/**
 * Check if a given object implements the PractitionerSearchResponse interface.
 */
export function instanceOfPractitionerSearchResponse(value: object): value is PractitionerSearchResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PractitionerSearchResponseFromJSON(json: any): PractitionerSearchResponse {
    return PractitionerSearchResponseFromJSONTyped(json, false);
}

export function PractitionerSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PractitionerSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PractitionerSearchResultFromJSON)),
    };
}

export function PractitionerSearchResponseToJSON(json: any): PractitionerSearchResponse {
    return PractitionerSearchResponseToJSONTyped(json, false);
}

export function PractitionerSearchResponseToJSONTyped(value?: PractitionerSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PractitionerSearchResultToJSON)),
    };
}

